export function formatBRLFromCents(cents) {
    const safe = cents ?? 0;
    return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
    }).format(safe / 100);
}

export function parseCentsFromInput(raw) {
    const s = String(raw ?? "").trim();
    const isNegative = s.startsWith("-");

    const digits = s.replace(/\D/g, "");
    const centsAbs = digits ? parseInt(digits, 10) : 0;

    return isNegative ? -centsAbs : centsAbs;
}